var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex flex-col" }, [
    _c(
      "div",
      { staticClass: "pb-2 flex items-end" },
      [
        _c(
          "field",
          {
            class: _vm.fieldClass,
            attrs: {
              label: "Servicer Name",
              disabled: _vm.disabled || _vm.servicerLoading,
              "error-text":
                _vm.validations !== null ? _vm.validations.servicerId : "",
            },
          },
          [
            _c("dropdown-field", {
              attrs: {
                source: _vm.servicerSource,
                "text-field": "name",
                "value-field": "id",
                placeholder: "Select Servicer",
                searchable: "",
                debounce: "500",
              },
              model: {
                value: _vm.model.servicerId,
                callback: function ($$v) {
                  _vm.$set(_vm.model, "servicerId", $$v)
                },
                expression: "model.servicerId",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.addServicer && _vm.entitledToEditCounterparty
          ? _c(
              "action",
              {
                staticClass: "pl-2",
                attrs: {
                  icon: "mdi mdi-plus-circle-outline pr-2",
                  disabled: _vm.disabled || _vm.servicerLoading,
                },
                on: {
                  click: function ($event) {
                    return _vm.addNewServicer()
                  },
                },
              },
              [_vm._v("Servicer")]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }